export const css = {
    root: '_2Wpa2Hsm',
    loading: '_2ahn0nv1',
    titleBlock: '_21JXE8ty',
    title: '_3rfE8tAU',
    gotitBlock: 'piTFVNaj',
    gotit: 'nkI-pGzd',
    section: '_1JaOG2_l',
    hero: '_2OGSK0sd',
    heroBanner: 'pqbuD9k7',
    heroSubtitle: '_3wzKynUd',
    heroIconList: '_1EtDM8gB',
    verticalAccordion: '_2rM0iZoP',
    accordion: '_10PLMQYZ',
    horizontalAccordion: '_30k1ghXW',
    storyline: 'f6VyPFtA',
    xref: '_6UDUHj7o',
    HCBullet: '_1sG8mr-S',
    HCBulletStyle2: '_2h5ALniu',
    TableUL: '_37YPede3',
    figure: '_1U8jRtiv',
    ph: '_3Mgar9AV',
    nextprev: '_3n8qQ7JG',
    next: '_3tsNYV55',
    previous: '_3e-qvcTz',
    ' _key': 'certwise-theme/certwise/book-widgets/topicpage'
};
export default css;
